import React from 'react';
import QuickLink from '../../components/basic/quickLink';
import Icon from '../../components/basic/icons';
import LogoImg from '../../assets/VE_Logo.png';
import Image from '../../components/basic/image';
import { useRouter } from '../../common/hooks/useRouter';
import { InternalLinks } from '../../common/enums/common';
import type { DisplayErrorBoundaryProps } from './interfaces/errorBoundary';

const DisplayErrorBoundary: React.FC<DisplayErrorBoundaryProps> = ({
  errMsg,
}): JSX.Element => {
  const { navigate } = useRouter();
  return (
    <>
      <div className="flex bg-secondary-400 px-8">
        <div className="my-0 mx-[90%] md:container md:mx-auto shadow-md py-3">
          <div className="flex justify-end items-center">
            <QuickLink
              href="https://healthy.kaiserpermanente.org/"
              isExternal={true}
              className="text-sm lg:text-md xl:text-md text-white flex justify-center mr-3"
            >
              <span className="underline underline-offset-4">kp.org</span>
              <Icon
                name="externalLink"
                className="ml-1 w-full text-sm md:text-lg lg:text-lg mt-1"
              ></Icon>
            </QuickLink>
          </div>
        </div>
      </div>
      <div className="flex bg-inky px-8">
        <div className="md:container md:mx-auto shadow-md py-3">
          <div className="flex justify-start items-center">
            <div data-testid="homebuttonDiv" onClick={() => navigate(InternalLinks.home)}>
              <Image
                src={LogoImg}
                alt="Vision Essentials"
                className="mr-4 self-start w-[308px] h-[54px]"
                layout="fixed"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="py-24 md:container md:mx-auto">
        <div className="font-medium text-[#003b71] text-[32px] font-['Gotham'] leading-10 px-4">
          Something went wrong
        </div>
        <div className="w-full ext-base text-black leading-normal pt-4 px-4">
          <p>{errMsg}</p>
        </div>
      </div>
      <div className="flex bg-inky px-8">
        <div className="md:container md:mx-auto shadow-md py-8">
          <div className="flex justify-start items-center">
            <Image
              src={LogoImg}
              alt="Vision Essentials"
              className="mr-4 self-start w-[220px] h-[40px]"
              layout="fixed"
            />
          </div>
          <div className="text-white text-base leading-normal tracking-tight">
            <div className="py-8">
              Kaiser Permanente members typically have coverage for medically necessary eye
              examinations, and some members, including those members with the pediatric vision
              benefit under their Affordable Care Act plan, may be able to apply a supplemental
              benefit to their purchases. Otherwise, the services and products described here are
              provided on a fee-for-service basis, separate from and not covered under your health
              plan benefits, and you are financially responsible to pay for them. For specific
              information about your covered health plan benefits, please see your Evidence of
              Coverage. (Photos of models shown, not actual patients)"
            </div>
            <div>
              <QuickLink
                href="/privacypolicy"
                className="text-sm lg:text-base text-white inline-block mr-0"
              >
                <span className="underline underline-offset-4">Privacy Policy</span>
              </QuickLink>
              <span> | </span>
              <QuickLink href="/tnc" className="text-sm lg:text-base text-white inline-block mr-3">
                <span className="underline underline-offset-4">Terms of Use</span>
              </QuickLink>
            </div>
            <div className="py-8">© 2024 Kaiser Permanente</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayErrorBoundary;
